import { Component, Input, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { PopoverController } from '@ionic/angular';
import { UserMenuComponent } from '../user-menu/user-menu.component';

@Component({
  selector: 'inc-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
  @Input() withBack: boolean;
  @Input() title: string;
  @Input() defHref = '/';
  @Input() color = 'primary';
  pracName = '';

  constructor(private storage: Storage, private popoverCtrl: PopoverController) { }

  async ngOnInit() {
    const user = await this.storage.get('user');
    this.pracName = user && user.displayName ? user.displayName : 'UNKNOWN_USER';
  }

  async openUserMenu(event: Event) {
    const userMenu = await this.popoverCtrl.create({
      component: UserMenuComponent,
      event
    });
    userMenu.present();
  }
}
